import { Await } from "react-router";
import { KeywordContext } from "@app/types/Page";
import CustomError from "@components/Error/CustomError";
import TemplateFactory from "@pages/Keyword/templates/TemplateFactory";
import { TRouteWithRedirect, useRouteContext } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

export default function KeywordPage(): React.ReactElement {
  const { context } =
    useRouteContext<TRouteWithRedirect<KeywordContext, string>>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <Await resolve={context.payload} errorElement={<CustomError />}>
      {({ kind, data }: KeywordContext) => {
        // Checker to make sure kind is from Keyword.
        if (kind !== "keyword") {
          return <CustomError statusCode={HttpStatusCode.NotFound} />;
        }

        // render keyword Template
        return <TemplateFactory data={data} />;
      }}
    </Await>
  );
}
